export default "__VITE_ASSET__C1G4ymPb__"